import { getCirclesGameState } from '@/shared/api/circles';
import { ErrorLogger } from '@/shared/service/logger/ErrorLogger';

import { usePlaydeckStoreRaw } from '../models/playdeck.store';

interface ShowCirclesScoreModalParams {
  score: number;
  gameKey: string;
  telegramId: number;
}

export const showCirclesScoreModal = ({
  score,
  gameKey,
  telegramId,
}: ShowCirclesScoreModalParams) =>
  new Promise<void>((resolve) => {
    const close = () => {
      usePlaydeckStoreRaw.setState({ circlesScoreModal: null, scoreModal: null });
      resolve();
    };

    usePlaydeckStoreRaw.setState({
      circlesScoreModal: { status: 'loading', score, resolve: close },
    });

    getCirclesGameState(gameKey, telegramId)
      .then((data) => {
        usePlaydeckStoreRaw.setState({
          circlesScoreModal: { status: 'ready', score, data, resolve: close },
        });
      })
      .catch((error) => {
        ErrorLogger.error(error as Error, 'getCirclesGameState failed, falling back');
        usePlaydeckStoreRaw.setState({
          circlesScoreModal: null,
          scoreModal: { score, resolve: close },
        });
      });
  });
